export default __webpack_public_path__ + "static/media/Logo_azul_winvest.e9f6d4cb.svg";